module.exports = __webpack_public_path__ + "img/brokerage-hero-background.bc7f8320.png";